module.exports = __webpack_public_path__ + "static/logo-1-1-3c946348c2ba53abd0a61999686ac042.png";